<template>
    <div>
        <common-table :table-columns="tableColumns"
                      :form-fields="formFields"
                      :permission="permission"
                      :url="url"
                      :operate="[]"
                      :searchs="searchs"
        />
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "Investment",
        components: { CommonTable },
        data() {
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'phone',
                    placeholder: '用户',
                    type: 'input'
                }, {
                    name: 'status',
                    placeholder: '请选择状态',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: '结束'
                    },{
                        key: 1,
                        value: '进行中'
                    }]
                }],
                permission: {
                    /*add: 'userDailyInvestmentIncome:add',
                    update: 'userDailyInvestmentIncome:update',
                    delete: 'userDailyInvestmentIncome:delete',
                    deleteBatch: 'userDailyInvestmentIncome:deleteBatch'*/
                },
                url: {
                    get: '/investment/listByCondition',
                    /*add: '/userDailyInvestmentIncome/add',
                    update: '/userDailyInvestmentIncome/update',
                    delete: '/userDailyInvestmentIncome/delete',
                    delete_batch: '/userDailyInvestmentIncome/deleteBatch',*/
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                  field: 'phone',
                  label: '用户',
                  show: true,
                  width: '',
                }, {
                    field: 'amount',
                    label: '金额',
                    show: true,
                    width: '',
                }, {
                    field: 'cycle',
                    label: '周期',
                    show: true,
                    width: '',
                }, {
                    field: 'remainingDays',
                    label: '剩余天数',
                    show: true,
                    width: '',
                }, {
                    field: 'purchasedDays',
                    label: '已购买天数',
                    show: true,
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '进行中',
                            type: 'success'
                        }, {
                            key: 0,
                            value: '结束',
                            type: 'warning'
                        }]
                    },
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    model: []
                }
            }
        }
    }
</script>

<style scoped>

</style>
